import logoSvg from "assets/svg/logo1.svg";

/** Atrium mark and wordmark, matching the admin sidebar. Used by the portal layouts and error pages. */
export default function AtriumLogo({ className = "" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`.trim()}>
      <img className="h-8 w-auto" src={logoSvg} alt="" />
      <span className="text-xl font-bold text-fg">Atrium</span>
    </div>
  );
}
